export const ProjObjOne = {
  id: "projects",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine6: "Genesis Shop",
  firstParagraph6:
    "Rebuilt three Hyundai e-commerce apps for Genesis — migrated from Webpack to Vite, Vue 2 to Vue 3, built a Genesis design system, updated the finance calculator, and updated components to support Genesis business logic.",
  techStacks6: "Vue 3, Vite, JavaScript, VueX, Vue Router, SCSS, Design Systems",
  imgStart6: false,
  img6: require("../../images/Genesis-Shop.png").default,
  alt6: "Genesis-Shop",

  topLine7: "Hyundai 3D Model",
  firstParagraph7:
    "Simplified 3D model rendering across Hyundai accessories and vehicle landing pages, cutting development time by 30% and reducing system complexity. Replaced hardcoded per-model logic with a JSON-driven system supporting multiple car variants and accessories. Built an admin editor allowing designers to show/hide 3D objects per variant without code changes, removing the dependency between developers and 3D designers.",
  techStacks7: "Vue 3, JavaScript, Three.js, Vue Router, VueX, JSON, SCSS",
  imgStart7: true,
  img7: require("../../images/Hyundai-3d-model.png").default,
  img7b: require("../../images/Hyundai-3d-model-with-accessories.png").default,
  alt7: "Hyundai-3D-Model",
  pathName7: "https://www.hyundai.com/au/en/cars/suvs/kona#variants:~:text=Engine%20%26%20Transmission%20Options",
  headline: "✨ Featured Work",
  topLine: "Pathfinding Visualizer",
  firstParagraph:
    "Web application for visualizing Pathfinding algorithms in actions. A pathfinding algorithm is used to find the shortest path between two points (start point and end point). Implemented Dijkstra, A* Search, Depth-first Search and Breadth-first Search.",
  techStacks: "React.js, CSS, Bootstrap",
  imgStart: false,
  img: require("../../images/Pathfinding-Visualizer-Project.PNG").default,
  alt: "Pathfinding-Visualizer-Project",
  pathName: "https://jonnylie.github.io/Pathfinding-Visualizer/",
  gitPathName: "https://github.com/Jonnylie/Pathfinding-Visualizer",
  dark: false,
  primary: false,
  darkText: false,
  gitIconMarginLeft: true,

  topLine2: "MLBB Pro",
  headline2: "✨ Featured Work",
  lightBg2: false,
  lightText2: true,
  lightTextDesc2: true,
  firstParagraph2:
    "Website to give detailed information about Mobile Legends game and teach people who are interested in playing the game. Created app from scratch using Webpack and Babel",
  techStacks2: "React/Redux, CSS, Webpack, Babel, React Router",
  imgStart2: true,
  img2: require("../../images/MLBBPro-Project.PNG").default,
  alt2: "MLBBPro-Project",
  pathName2: "https://mlpro.netlify.com",
  gitPathName2: "https://github.com/Jonnylie/MLPro",
  dark2: false,
  primary2: true,
  darkText2: false,
  gitIconMarginLeft: true,

  topLine3: "WonderEats",
  firstParagraph3:
    "Mobile application for ordering food online from Indonesian restaurants in Sydney. Builds an android application for restaurants and customers. Implemented food order, order history, view foods by category, search menu, authentication, login, cart, email notification and payment system.",
  techStacks3:
    "Kotlin, Node.js, Cloud Firestore, Nodemailer, Android SDK, Firebase Cloud Function, Stripe, XML",
  img3: require("../../images/WonderEats-Project.PNG").default,
  alt3: "WonderEats-Project",
  pathName3: "https://youtu.be/s7T7RTb051A",
  googlePlayPathName3:
    "https://play.google.com/store/apps/details?id=au.com.wondereats&hl=en_AU&gl=US",

  topLine4: "My Porfolio",
  firstParagraph4:
    "A react portfolio site built with React Hooks and Styled Components. In addition, I am integrating Docker to this project. This website highlights my recent projects and introduces more about myself",
  techStacks4:
    "React.js, Docker, React Hooks, Styled Components, React Router, CSS",
  img4: require("../../images/My-Portfolio-Project.PNG").default,
  alt4: "My-Portfolio-Project",
  pathName4: "https://jonnylie.netlify.app/",
  gitPathName4: "https://github.com/Jonnylie/react-portfolio",
  gitIconMarginLeft: true,

  topLine5: "Ecommerce App",
  firstParagraph5:
    "Mobile apps built with react native to buy audio equipment online, including headphones and earbuds. Using some animations and page transition to improve user experience. Project Features: user registration and login with firebase, shopping cart, product order, purchase history.",
  techStacks5:
    "React Native, CSS, React Hooks, Redux, Redux-Thunk, Animated API, React Navigation 5, Shared Element and Firebase for database (NoSQL) and authentication",
  img5: require("../../images/Ecommerce.png").default,
  alt5: "Ecommerce-App-Project",
  gitPathName5: "https://github.com/Jonnylie/Ecommerce",
  pathName5: "https://youtu.be/",
  gitIconMarginLeft2: false,
};
